import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RmaIconComponent } from '@rma/generic/ui/icon';

type BulletStyle = 'number' | 'check' | 'error' | 'close' | 'block';

@Component({
  // There are a few cases where you give a component an attribute, such as when you want to augment a built-in element. e.g. in this case <li> this will never be used on custom elements. Confirmed with Tom Stone and we're going to trial.
  // https://angular.io/guide/styleguide#style-05-03
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[rma-list-item]',
  templateUrl: './list-item.component.html',
  styleUrls: ['./list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RmaIconComponent],
  host: {
    '[class.number]': 'isNumber()',
  },
})
export class ListItemComponent {
  readonly bulletStyle = input<BulletStyle>('number');

  readonly isNumber = computed(() => this.bulletStyle() === 'number');
  readonly bullet = computed(() => {
    const style = this.bulletStyle();

    if (style === 'number') {
      return undefined;
    }

    return style;
  });
}
